import React from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
// import TeamImage from './TeamImage.png'
import {HeaderView} from '../HeaderView/HeaderView'
import {FooterLinks} from '../FooterLinks/FooterLinks'
import {SocialView} from '../SocialView/SocialView'
import {FooterNote} from '../FooterLinks/FooterNote'
import {fetchMenusIfNeeded, selectSponsorMenu,
        fetchSponsorMenuIfNeeded, CLIENT_BASE_URL} from '../../actions'

export class SponsorFullView extends React.Component {

  constructor (props) {
    super(props)
    this.renderSponsors = this.renderSponsors.bind(this)
    this.renderIcons = this.renderIcons.bind(this)
    this.renderIcon = this.renderIcon.bind(this)
  }

  componentWillMount (p) {
    const {match, dispatch} = this.props
    if (Object.keys(match.params).length) {
      dispatch(selectSponsorMenu(match.params[0]))
      dispatch(fetchSponsorMenuIfNeeded(match.params[0], this.props.selectedScope))
    } else {
      dispatch(selectSponsorMenu(''))
    }
  }

  componentDidMount () {
    const {dispatch, match} = this.props
    dispatch(fetchMenusIfNeeded(this.props.selectedScope))
    dispatch(selectSponsorMenu(match.params[0]))
  }

  componentWillReceiveProps (nextProps) {
    const {match, dispatch} = nextProps
    if (match.params !== this.props.match.params) {
      dispatch(fetchMenusIfNeeded(nextProps.selectedScope))
    }

    if (Object.keys(this.props.match.params).length && Object.keys(match.params).length &&
    this.props.match.params[0] !== match.params[0]) {
      dispatch(selectSponsorMenu(match.params[0]))
      dispatch(fetchSponsorMenuIfNeeded(match.params[0], nextProps.selectedScope))
    }
  }

  renderIcon (info) {
    const src = CLIENT_BASE_URL + info.thumb
    return (
      <div key={`${info.id}z`} className='col-sm-6 col-md-3 col-lg-3 no-pad-left box'>
        <a key={`${info.id}a`} href={info.link} target='_blank'>
          <img key={`${info.id}b`} src={src} />
        </a>
        <p key={`${info.id}c`} className='desc'>{info.description}</p>
      </div>
    )
  }

  renderIcons (sponsors) {
    return sponsors.map((info, i) => {
      return this.renderIcon(info)
    })
  }

  renderSponsors () {
    const {sponsor} = this.props

    let sponsorByTag = {}
    if (typeof sponsor.reduce === 'function') {
      sponsorByTag = sponsor.reduce((nextState, s) => {
        if (!nextState.hasOwnProperty(s.tag_name)) {
          nextState[s.tag_name] = []
        }

        nextState[s.tag_name].push(s)
        return nextState
      }, {})
    }

    // console.log('sponsorByTag', sponsorByTag)
    return (
      Object.keys(sponsorByTag).map((tag, i) => {
        return (
          <div key={i} className='row'>
            <div key={`${i}d`} className='col-sm-12 col-md-10 col-lg-10'>
              <p key={`${i}e`} className='title'>{tag}</p>
              {this.renderIcons(sponsorByTag[tag])}
            </div>
          </div>
        )
      })

      // <p className='title' dangerouslySetInnerHTML={{ __html: info.title }}></p>
    )
  }

  render () {
    const {menus, selectedSponsorMenu, dispatch} = this.props
    const bottom_menus = menus.bottom || []
    const top_menus = menus.top || []

    // console.log('sponsor', sponsor)
    if (typeof selectedSponsorMenu === 'undefined') {
      return
    }

    return (
      <div>
        <HeaderView top_menus={top_menus} dispatch={dispatch}/>
        <div id='sponsor-full-view' className='team-view'>
          <div className='row'>
            <div className='col-md-12 no-pad text-left'>
              <p className='left-tag'>Patrocinadores</p>
            </div>
          </div>
          <div className='main-block'>
            {this.renderSponsors()}
          </div>
        </div>

        <FooterLinks bottom_menus={bottom_menus}/>
        <SocialView customclass='lite'/>
        <FooterNote />
      </div>
    )
  }
}

SponsorFullView.propTypes = {
  dispatch: PropTypes.func.isRequired,
  
  menus: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]).isRequired,
  sponsor: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]).isRequired,
  selectedSponsorMenu: PropTypes.string.isRequired,
  selectedScope: PropTypes.string.isRequired
}

function mapStateToProps (state) {
  const {getMenus, selectedSponsorMenu, getSponsorMenu, selectedScope} = state

  const {
    isFetchingMenus,
    lastUpdatedMenus,
    items: menus
  } = getMenus[selectedScope] || {
    isFetchingMenus: true,
    items: {}
  }

  const {
    isFetchingSpMenu,
    items: sponsor
  } = getSponsorMenu[selectedScope + '_' + selectedSponsorMenu] || {
    isFetchingSpMenu: true,
    items: []
  }

  return {
    isFetchingMenus,
    lastUpdatedMenus,
    menus,
    isFetchingSpMenu,
    sponsor,
    selectedSponsorMenu,
    selectedScope
  }
}

export default connect(mapStateToProps)(SponsorFullView)



// WEBPACK FOOTER //
// ./src/views/SponsorView/SponsorFullView.js